// Single source of truth for tenant-host detection on *.kanarix.online.
// Shared by all three runtimes that must agree on what counts as a tenant:
//   - the SPA (src/lib/tenant-host.ts)
//   - the Pages Functions root middleware (functions/_middleware.ts)
//   - the kanarix-sites Worker (workers/sites/index.ts)
// Top-level shared/ is the home for cross-runtime constants — src/ is bundled
// only into the SPA and functions/ only into Pages, so neither can host them.

// Customer websites live on *.kanarix.online (kept OFF the kanarix.es brand
// domain so tenant content never affects Kanarix's SEO).
export const TENANT_BASE = '.kanarix.online';

// Infra/mail/app labels that are never a tenant site — the app/landing/demo,
// plus cold-mail subdomains, so none of them get tenant-site serving.
export const RESERVED_TENANT_LABELS = new Set([
  'www', 'app', 'admin', 'api', 'mail', 'email', 'mailer', 'smtp', 'mx', 'mta',
  'send', 'em', 'track', 'click', 'cdn', 'staging', 'demo',
]);

// Returns the tenant slug for a host, or null for the app itself, reserved
// labels, the apex, multi-level hosts, *.pages.dev previews, and localhost.
export function getTenantLabel(host: string): string | null {
  const h = host.toLowerCase();
  if (!h.endsWith(TENANT_BASE)) return null;
  const label = h.slice(0, -TENANT_BASE.length);
  if (!label || label.includes('.') || RESERVED_TENANT_LABELS.has(label)) return null;
  return label;
}
